import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Config {

  public ApplicationName: string = 'United Neon MDS';
  public SchemaName: string = 'UNMDS';
  public NotificationAppID: string = '0';

  public User: any = new Array();

  public PageSize: number = 100;
  public EditablePageSize: number = 100;

  public BaseURL: string;
  public LocalURL: string;
  public SourceURL: string;
  public URL: string;
  public NotificationURL: string;
  public UploadURL: string;
  public DeleteURL: string;
  public DefaultURL: string;
  public TemplateURL: string;
  public Directory: string;

   public Debug: boolean = false; // false

  public Version: string = '2025.09.25.2202';

  constructor(
  ) {
/*
    NOTE:
      DefaultURL
      TemplateURL
      Directory
    - use global.XMLEncode
*/
    // this.SourceURL = environment.SourceURL;
    // this.URL = environment.URL;
    // this.NotificationURL = environment.NotificationURL;
    // this.UploadURL = environment.UploadURL;
    // this.DeleteURL = environment.DeleteURL;
    // this.DefaultURL = environment.DefaultURL;
    // this.TemplateURL = environment.TemplateURL;
    // this.Directory = environment.Directory;

    // if (this.Debug === true) {
      // this.LocalURL = 'http://localhost:8100/';
      // this.SourceURL = 'http://bispen/unmds/';
      // this.BaseURL = 'http://localhost:8100/';
    // } else {
      this.LocalURL = 'https://unmds.testyoursolutions.com/unmds/';
      this.SourceURL = 'https://unmds.testyoursolutions.com/unmds/';
      this.BaseURL = 'https://unmds.testyoursolutions.com/';
    // }

    this.URL = this.SourceURL + 'r2t2post.php';
    this.NotificationURL = this.SourceURL + 'onesignal.php';
    this.UploadURL = this.SourceURL + 'upload.php';
    this.DeleteURL = this.SourceURL + 'delete.php';
    this.DefaultURL = this.SourceURL + 'uploads/';
    this.TemplateURL = this.SourceURL + 'templates/';
    this.Directory = this.SourceURL + 'uploads/';

    this.UserDefaults();
  }

  UserDefaults() {
    this.User['UsersKey'] = '';
    this.User['FirstName'] = '';
    this.User['UserName'] = '';
    this.User['Administrator'] = false;
    this.User['Internal'] = false;
    this.User['UserType'] = '0';
    this.User['InHouseSales'] = false;
    this.User['Encoder'] = false;
    this.User['AccountManager'] = false;
    this.User['SalesUnit'] = '';
    this.User['TechSales'] = false;
    this.User['SolutionsEngineer'] = false;
    this.User['Approver'] = false;
    this.User['ApproverLevel'] = 0;
    this.User['Vendor'] = '';
    this.User['PriceList'] = false;
    this.User['Project'] = false;
    this.User['Currency'] = '';
    this.User['ModulesString'] = '';
    this.User['RightsString'] = '';
    this.User['Modules'] = new Array();
    this.User['Rights'] = {};
    this.User['PictureURL'] = '';
    this.User['Signature'] = '';
    this.User['TokenID'] = '';
    this.User['IPAddress'] = '';
    this.User['SessionID'] = '';
  }

  SetUserConfig(Config: string, Value: any = null) {
    if ((['Modules', 'Rights']).indexOf(Config) !== -1) {
      if (this.User[Config + 'String'] !== '') {
        this.User[Config] = JSON.parse(JSON.parse(this.User[Config + 'String']));
      }
    } else {
      switch (typeof(this.User[Config])) {
        case 'boolean':
          this.User[Config] = this.ToBoolean(Value);
          break;

        case 'number':
          this.User[Config] = this.ParseFloat(Value);
          break;

        default:
          this.User[Config] = Value;
          break;
      }
    }
  }

  IsUndefined(Parameter: any, Arbitrary: any) {
    if ((Parameter === undefined) &&
        (Arbitrary === undefined)) {
      return '';
    } else if ((Parameter === null) ||
               (Arbitrary === null)) {
      return '';
    } else if (Parameter === undefined) {
      return Arbitrary;
    } else if (typeof(Parameter) === 'string') {
      return (Parameter.trim());
    } else {
      return Parameter;
    }
  }

  ToBoolean(Input: any) {
    if ((Input === undefined) ||
        (Input === null)) {
      return (false);
    } else {
      switch (Input.toString().toUpperCase()) {
        case '1':
        case 'TRUE':
          return true;
          break;
        default:
          return false;
          break;
      }
    }
  }

  ParseFloat(number: string, AllowNegative: boolean = true) {
    if (this.IsUndefined(number, '') !== '') {
      let returnStr: string;
      returnStr = this.IsUndefined(number, '0').toString();
      returnStr = returnStr.replace (/,/g, '');
      if ((parseFloat(returnStr) < 0) &&
          (AllowNegative === false)) {
        return (0);
      } else {
        return (parseFloat(returnStr));
      }
    } else {
      return (0);
    }
  }
}
